import React from 'react';
import PropTypes from 'prop-types';
import { TwitterTweetEmbed } from 'react-twitter-embed';

const TweetCard = ({ tweet_id: tweetId }) => {
  if (!tweetId) {
    return null;
  }

  return (
    <div className='tweet-card'>
      <TwitterTweetEmbed tweetId={tweetId} />
    </div>
  );
};

TweetCard.propTypes = {
  tweet_id: PropTypes.string,
};

export default TweetCard;
